export default __webpack_public_path__ + "static/media/marquee3.91a61092.png";